import Popup from 'reactjs-popup';
import styled from 'styled-components';

import Button from '../Button/Button';

export const PopupStyled = styled(Popup)`
  &-overlay {
    background: rgba(0, 0, 0, 0.4);
    padding: 20px;
  }

  &-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 50px 40px 25px;
    border-radius: 9px;
    max-width: 820px;
    width: 100%;
    max-height: 100%;
    overflow: auto;

    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const CloseButtonStyled = styled.button`
  margin-left: auto;
  width: 14px;
  height: 14px;
  cursor: pointer;
  background-image: url('/images/icons/close.svg');
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 2;
`;

export const ControlsWrapperStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  padding: 15px 15px 0 40px;
`;

export const TopButtonStyled = styled(Button)`
  position: absolute;
  bottom: 10px;
  right: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ theme }) => `
    color: ${theme.primaryColour};
  `}
`;

export const ContentSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;
